<template>
  <footer class="foot">
    <div class="wrap">
      <ul class="nav">
        <li>
          <a href="https://search.51job.com/list/190200,000000,0000,00,9,99,%25E6%25B9%2596%25E5%258D%2597%25E7%25BA%25A2%25E6%259D%258F%25E6%259E%2597%25E6%2596%2587%25E5%258C%2596%25E4%25BC%25A0%25E6%2592%25AD%25E6%259C%2589%25E9%2599%2590%25E5%2585%25AC%25E5%258F%25B8,2,1.html" target="_blank">加入我们</a>
        </li>
        <li>
          <router-link to="/contact">联系我们</router-link>
        </li>
      </ul>

      <div class="addr">
        <!-- <img src="../assets/icon_map.png" alt=""> -->
        <span>地址：长沙市高新开发区青山路699号湖南省军民融合科技创新产业园6#栋803室</span>
      </div>

      <p class="copyRight">湖南红杏林科技有限公司 版权所有     <a href="https://beian.miit.gov.cn/#/">备案号：湘ICP备20011791号-1</a></p>

    </div>

    <div class="goTop" v-if="scrollTop > 1000" @click="gotop">▲</div>
  </footer>
</template>

<script>
import store from '@/store';
export default {
  name: 'foot',
  data(){
    return {
      scrollTop:0,
      can:true
    }
  },
  mounted(){
    let that = this;
    window.onscroll = function(e){
      if(that.can){
        that.can = false;
        console.log(e);
        console.log(e.pageY);
        that.scrollTop = that.getScroll();
        store.commit('increment',that.scrollTop);
      }
    }
    setInterval(()=>{
      this.can = true;
    },200)
  },
  methods:{
    gotop(){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    getScroll(){
      var scrollTop=0;
      if(document.documentElement&&document.documentElement.scrollTop){
            scrollTop=document.documentElement.scrollTop;
      }else if(document.body){
            scrollTop=document.body.scrollTop;
      }
      return scrollTop;
    }
  }
}
</script>

<style scoped>
.foot{
  width: 100%;
  text-align: center;
  background: #CACACA;
}
.wrap{
  max-width: 1165px;
  margin: 0 auto;
  padding: 50px 0;
  font-size: 15px;
}
.nav{
  margin: 0 auto;
}
.nav li{
  display: inline-block;
  margin: 0 30px;
}
.nav li a{
  text-decoration: underline;
}
.addr{
  margin-top: 40px;
  height: 30px;
  line-height: 30px;
}
.addr img{
  width: 17px;
  height: 23px;
  margin-right: 15px;
  display: inline-block;
}
.copyRight{
  font-size: 16px;
}
.goTop{
  width: 60px;
  height: 60px;
  background: #9D2933;
  color: #fff;
  text-align: center;
  line-height: 60px;
  position: fixed;
  bottom: 50px;
  right: 50px;
  border: 1px solid #fff;
  font-size: 30px;
  cursor: pointer;
}
</style>
